import { PhoneField } from "components/phone-field";
import { TextField } from "components/text-field";
import { PsychologistProfile } from "core/types";
import { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import { styled } from "styled-components";
import { type PhoneFieldChangeValue } from "components/phone-field";

type EditablePhoneNumberAndHsaProps = {
  psychologist: Pick<PsychologistProfile, "phone" | "hsa">;
  psychologistValidation: string[];
  demo: boolean;
  onChange: (
    x: string,
  ) => (arg: PhoneFieldChangeValue | ChangeEvent<HTMLInputElement>) => void;
};

const EditablePhoneNumberAndHsa = ({
  psychologist,
  psychologistValidation,
  onChange,
}: EditablePhoneNumberAndHsaProps) => {
  const { t } = useTranslation();

  return (
    <div>
      <PhoneField
        sensitive={true}
        value={psychologist.phone ?? ""}
        label={`${t("PHONE_NUMBER")}*`}
        onChange={onChange("phone")}
        error={psychologistValidation.indexOf("phone") !== -1}
        errorMessage={t("PHONE_NUMBER_NOT_VALID")}
      />
      <StyledTextFieldWrapper>
        <TextField
          label={t("HSA_ID")}
          value={psychologist.hsa ?? ""}
          sensitiveField={true}
          onChange={onChange("hsa")}
        />
      </StyledTextFieldWrapper>
    </div>
  );
};

const StyledTextFieldWrapper = styled.div`
  .MuiFormControl-marginNormal {
    margin-top: 0;
  }
`;

export default EditablePhoneNumberAndHsa;
